// Modules
import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
// @ingka
import '@ingka/hyperlink/style.scss';
import '@ingka/focus/style.scss';
import Breadcrumb from '@ingka/breadcrumb';
import Hyperlink from '@ingka/hyperlink';
import '@ingka/breadcrumb/style.scss';

import './BCrumb.scss';
import { ROUTE_BASE, ROUTE_CUSTOMER_SERVICE, ROUTE_MKT_BREADCRUMB } from 'Constants/routes';
import { useGetTopicQuery } from 'Services/api/index';

const { PHRASE_TRANSLATIONS } = process.env.REACT_APP_MARKET_VALUES;

const BCrumb = () => {
    const { data: pages, error } = useGetTopicQuery();

    const lastCrumb = error ? error.message : pages?.headline;

    const bcrumbPathName = [
        { url: ROUTE_MKT_BREADCRUMB, location: PHRASE_TRANSLATIONS.rootHome },
        {
            url: ROUTE_CUSTOMER_SERVICE,
            location: PHRASE_TRANSLATIONS.rootCustomerService,
        },
        { url: ROUTE_BASE, location: lastCrumb },
    ];

    return (
        <Breadcrumb className="breadcrumb" data-cy="breadcrumb">
            {bcrumbPathName.map((item, index) => (
                <Hyperlink url={item.url} key={index}>
                    <span className="breadcrumb__item" data-cy="crumb">
                        {item.location}
                    </span>
                </Hyperlink>
            ))}
        </Breadcrumb>
    );
};

BCrumb.propTypes = {
    location: PropTypes.object.isRequired,
};

export default withRouter(BCrumb);
